import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { BaseFormGroup } from 'src/app/shared/form-input-components/base-form-group';
import { CommonBookingService } from '../common-booking.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { phoneValidator } from 'src/app/shared/validators/phone-validator';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-add-cab-form',
  templateUrl: './add-cab-form.component.html',
  styleUrls: ['../../../shared/styles/form.scss', './add-cab-form.component.scss']
})
export class AddCabFormComponent extends BaseFormGroup implements OnInit {

  @Input() booking: any;
  @Input() validateRegNo: boolean;
  @Output() closeCallback = new EventEmitter();
  @Output() addCallback = new EventEmitter();

  public formDetails: FormGroup;
  public vendors: any[];
  public isUserVendor: any;
  public addCabError: string;
  public isLoading: boolean;

  constructor(private commonBookingService: CommonBookingService, private commonService: CommonService,
              private authService: AuthService) {
    super();
  }

  ngOnInit() {
    this.isUserVendor = this.authService.isUserVendor();
    this.commonService.getEtsData().subscribe((response) => {
      this.vendors = response.vendors;
      const registrationRegex = new RegExp(/[A-Za-z0-9]{4,}[0-9]{4}/);
      let registrationNoValidator;
      if (this.validateRegNo) {
        registrationNoValidator = [Validators.required, Validators.pattern(registrationRegex)];
      }
      else {
        registrationNoValidator = Validators.required;
      }
      this.formDetails = new FormGroup({
        driverName: new FormControl('', Validators.required),
        driverContact: new FormControl(null, [Validators.required, phoneValidator]),
        registrationNo:  new FormControl('', registrationNoValidator),
        vendorId: new FormControl( this.booking.vendor ? this.booking.vendor.guid :  '', Validators.required),
        cabModel:  new FormControl('', Validators.required),
        comment: new FormControl('')
      });
    });
  }

  cancelCallback = () => {
    this.closeCallback.emit();
  }

  onSubmitClick = () => {
    if (!this.formDetails.valid) {
      this.markFormGroupDirty(this.formDetails);
    } else {
      this.isLoading = true;
      const request = Object.assign({}, this.formDetails.getRawValue(), {
        bookingId: this.booking.bookingId,
        buId: this.authService.user.buId,
        modifierGuid: this.authService.user.employeeGuid,
        modifierBuid: this.authService.user.buId
      });
      this.commonBookingService.addCab(request).subscribe((response) => {
        this.isLoading = false;
        this.addCallback.emit(response);
        this.cancelCallback();
      }, (response) => {
        this.isLoading = false;
        this.addCabError = response.error.message;
      });
    }
  }

  hideAddCabError = () => {
    this.addCabError = '';
  }

  getVendorValue = (option) => {
    return option.guid;
  }

  getVendorLabel = (option) => {
    return option.vendorName;
  }

}
